// extracted by mini-css-extract-plugin
module.exports = {"content":"InsightPostAvatar__content__pfQl8","image":"InsightPostAvatar__image__SOK0M"};